import { isYMEnabled } from './is-ym-enabled';
import { BannerEvent } from '../../models/ya-metrica-events';

type BannerEventType = 'campaign' | 'discount';

export const pushBannerEvent = (
  event: BannerEvent,
  name: string,
  type: BannerEventType,
): void => {
  if (isYMEnabled() && !!name && !!event) {
    const payload: Record<string, any> = { event };
    if (type === 'campaign') {
      payload.campaign_name = name;
    } else if (type === 'discount') {
      payload.discount_name = name;
    }
    window?.dataLayer?.push(payload);
  }
};
